module.exports = __webpack_public_path__ + "assets/pdf/California ZEV Investment Plan Cycle 1.3bc672a3.pdf";